import {
  recordContractUtilizationBadgeImpression,
  useRecordContractUtilizationBadgeInteractionMutation,
} from '@cartwheel/api/v1'
import { useEffect, useRef, useState } from 'react'
import type { FeedbackSentiment } from './contract-utilization-feedback-modal'
import { FeedbackModal } from './contract-utilization-feedback-modal'

export interface ContractUtilizationFeedbackBadgeProps {
  feedback_state: string
}

function ContractUtilizationFeedbackBadge({
  feedback_state,
}: ContractUtilizationFeedbackBadgeProps) {
  const hasFiredRef = useRef(false)
  console.log('feedback_state', feedback_state)
  const [shouldDismiss, setShouldDismiss] = useState<boolean>(feedback_state === 'dismissed')
  const [modalOpen, setModalOpen] = useState(false)
  const [sentiment, setSentiment] = useState<FeedbackSentiment>('positive')

  const badgeInteractedMutation = useRecordContractUtilizationBadgeInteractionMutation()

  useEffect(() => {
    if (hasFiredRef.current) return
    hasFiredRef.current = true
    recordContractUtilizationBadgeImpression().catch(() => {})
  }, [])

  const handleThumbsUp = () => {
    badgeInteractedMutation.mutate({ body: { helpful: true } })
    setSentiment('positive')
    setModalOpen(true)
  }

  const handleThumbsDown = () => {
    badgeInteractedMutation.mutate({ body: { helpful: false } })
    setSentiment('negative')
    setModalOpen(true)
  }

  if (shouldDismiss) {
    return null
  }

  return (
    <div className="flex shrink-0 justify-end">
      <div className="flex items-center gap-3 rounded-full border bg-sky-25 border-sea-light px-5 py-1 whitespace-nowrap">
        <span className="text-sm font-medium text-charcoal">Is this helpful?</span>
        <div className="flex items-center gap-4">
          <button
            type="button"
            onClick={handleThumbsUp}
            className="text-charcoal-75 hover:text-forest transition-colors text-lg"
            title="Thumbs up"
            aria-label="Thumbs up"
          >
            <i className="fa-regular fa-thumbs-up" aria-hidden="true" />
          </button>
          <button
            type="button"
            onClick={handleThumbsDown}
            className="text-charcoal-75 hover:text-brick-light transition-colors text-lg"
            title="Thumbs down"
            aria-label="Thumbs down"
          >
            <i className="fa-regular fa-thumbs-down" aria-hidden="true" />
          </button>
        </div>
      </div>
      <FeedbackModal
        isOpen={modalOpen}
        sentiment={sentiment}
        onSentimentChange={setSentiment}
        onClose={() => {
          setModalOpen(false)
          setShouldDismiss(true)
        }}
        onSubmitted={() => {
          setModalOpen(false)
          setShouldDismiss(true)
        }}
      />
    </div>
  )
}

export { ContractUtilizationFeedbackBadge }
export default ContractUtilizationFeedbackBadge
